import { IContent } from 'interface/lesson';
import { useState } from 'react';
import WaterMark from './WaterMark';
import './styles.css';

interface IVideoProps {
  content: IContent;
  drmActive: number | boolean;
}

const Video = ({ content, drmActive }: IVideoProps) => {
  const [anchorEl, setAnchorEl] = useState<any>(null);

  const handleOpen = (event: any) => setAnchorEl(event.currentTarget);

  const formatUrl = (url: string) => {
    const hasQuery = /\?.+=.*/g.test(url);
    if (hasQuery) return `${url}&transparent=0`;
    return `${url}?transparent=0`;
  };

  return (
    <div>
      <div className='video-player-container' onLoad={handleOpen}>
        {Boolean(drmActive) && <WaterMark />}
        <iframe
          title='videoplayer'
          src={formatUrl(content.embed)}
          allowFullScreen
          allow='geolocation; microphone; camera'
        />
      </div>
    </div>
  );
};

export default Video;
